const {get_url_parameter} = require('../helpers/_utils');

module.exports = function init_photo_contest() {
  (function ($) {
    
    if($('.page-photo-contest').length > 0) {
      
      const MAX_PHOTOS = 5;
      const STORAGE_KEY = 'contest_user_info';

      // listen for appearance of confirmation message
      // to hide photo count warning
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            if($('.gform_confirmation_wrapper').length > 0) {
              $('#photo-count-warning').html('');
            }
          }
        });
      });

      observer.observe(document.querySelector('.page-photo-contest'), {
        childList: true,
        subtree: true
      });


      // store user meta in case they want to enter again
      $('.page-photo-contest form.nbc-photo-contest-form').on('submit', function() {

        const user_meta = {
          'fname': $('.name_first input').val(),
          'lname': $('.name_last input').val(),
          'phone': $('.ginput_container_phone input').val(),
          'email': $('.ginput_container_email input').val()
        };

        localStorage.setItem(STORAGE_KEY, JSON.stringify(user_meta));

      });

      // on page load, check if this is re-entry
      // and load user meta if it exists
      if(get_url_parameter('ea')) {
        
        const saved_meta = localStorage.getItem(STORAGE_KEY);
        
        if (!saved_meta) return false;
        const form_data = JSON.parse(saved_meta);

        $('.name_first input').val(form_data.fname);
        $('.name_last input').val(form_data.lname);
        $('.ginput_container_phone input').val(form_data.phone);
        $('.ginput_container_email input').val(form_data.email);
      } else {
        // otherwise, clear the stored data and start fresh
        localStorage.removeItem(STORAGE_KEY);
      }


      // limit date picker to the allowable photo-taken date range,
      // configurable on the NBC Options > Photo Contest Options page
      const contest_settings = (typeof nbc_settings !== 'undefined' && nbc_settings.photo_contest) || {};

      gform.addFilter('gform_datepicker_options_pre_init', function(options, form_id, field_id) {
        var range = {
          start: new Date(contest_settings.date_range_start || '10/01/2025'),
          end: new Date(contest_settings.date_range_end || '09/30/2026')
        };

        options.minDate = range.start;
        options.maxDate = range.end;
        options.beforeShowDay = function(date) {
          if(date >= range.start && date <= range.end) {
            return [true, ''];
          } else {
            return [false, ''];
          }
        }

        return options;

      });

      // listen for photo uploads
      // -> update photo count warning
      // -> make sure different photos are being uploaded
      $(document).on('change', '.page-photo-contest form.nbc-photo-contest-form input[type=file]', function() {
        update_photo_count();
        update_duplicate_photo_message();
      });
    
      const originalGformDelete = window.gformDeleteUploadedFile;

      // override gform delete function to catch this action and recalculate photo count
      window.gformDeleteUploadedFile = function(formId, fieldId, element) {

        // call the original function
        const result = originalGformDelete.call(this, formId, fieldId, element);
        
        // update the count (with small delay to let DOM update)
        setTimeout(function() {
          update_photo_count();
        }, 50);
        
        return result;
      };

      // also update photo count and duplicate filename warnings after validation
      $(document).on('gform_post_render', function() {
        update_photo_count();
        update_duplicate_photo_message();
      });

      function update_photo_count() {
        const preview_count = $('.page-photo-contest form.nbc-photo-contest-form .ginput_preview').length;
        const input_count = $('.page-photo-contest form.nbc-photo-contest-form input[type=file]').filter(function() {
          return this.files && this.files.length > 0;
        }).get().reduce((total, input) => total + input.files.length, 0);
        
        const total_count = preview_count + input_count;
        if(total_count < MAX_PHOTOS) {
          const message_template = contest_settings.photo_count_warning_message || 'NOTE: You\'ve uploaded {count} photo(s) but may upload up to {max}.';
          const message = message_template.replace('{count}', total_count).replace('{max}', MAX_PHOTOS);
          $('#photo-count-warning').html('<p>' + message + '</p>');
        } else {
          $('#photo-count-warning').html('');
        }
      }

      function update_duplicate_photo_message() {

        const filenames = [];
        const duplicates = [];
        
        // get file names from preview areas (already uploaded files)
        $('.page-photo-contest form.nbc-photo-contest-form .ginput_preview').each(function() {
          const filename = $(this).find('.gfield_fileupload_filename').html().trim();
          if(filename) {
            if (filenames.includes(filename)) {
              if (!duplicates.includes(filename)) {
                duplicates.push(filename);
              }
            } else {
              filenames.push(filename);
            }
          }
        });
        
        // get file names from file inputs (newly selected files)
        $('.page-photo-contest form.nbc-photo-contest-form input[type=file]').each(function() {
          if (this.files && this.files.length > 0) {
            for (let i = 0; i < this.files.length; i++) {
              const filename = this.files[i].name;
              if (filenames.includes(filename)) {
                if (!duplicates.includes(filename)) {
                    duplicates.push(filename);
                }
              } else {
                filenames.push(filename);
              }
            }
          }
        });
        
        // display warning if duplicates found
        if (duplicates.length > 0) {
          const message_template = contest_settings.duplicate_filename_warning_message || 'NOTE: Duplicate file names detected: {filenames}. Was the same photo uploaded multiple times?';
          const message = '<p>' + message_template.replace('{filenames}', duplicates.join(', ')) + '</p>';
          $('#duplicate-filename-warning').html(message);
        } else {
            $('#duplicate-filename-warning').html('');
        }
      }

      // listen for file upload size errors and customize message
      $('.gform_wrapper input[type="file"]').on('change', function() {

        const vmsg = $(this).closest('.ginput_container_fileupload').find('.validation_message').html();
        if(vmsg && vmsg.indexOf('size') != -1) {
          const error_message = contest_settings.file_size_error_message || '. Click the Choose File button to upload a smaller file.';
          $(this).closest('.ginput_container_fileupload').find('.validation_message').html(vmsg + error_message);
        }
        
     });

    } // end if page photo contest

    



  })(jQuery);
}
